import { TransactionType } from '@ankor-io/common/types/transaction/transaction'

export const getTransactionTypeText = (transactionType: TransactionType): string => {
  switch (transactionType) {
    case TransactionType.ANKOR_PAY:
      return 'AnkorPay'
    case TransactionType.MANUAL:
      return 'Manual'
    default:
      return transactionType
  }
}
